<template>
  <div class="main">
    <div class="stores">
      <get-more :on-load-more="onLoadMore" :enable-load-more="enableLoadMore" :load-more-text="loadMoreText">
        <div v-for="(item, index) of rentList" :key="index" class="store">
          <div class="store-title">
            <h1>
              找{{ cityName }}{{ item.title }} {{ envId === 0 ? item.id : '' }}
            </h1>
            <span>官方认证</span>
          </div>
          <p class="content">
            {{ item.description || '暂无描述' }}
          </p>
          <div class="store-chat">
            <p>联系人：{{ item.contact || '匿名用户' }}</p>
            <div @click="getPhone(item)">
              <img src="@/imgs/home_call.png">
              <span>联系方式</span>
            </div>
          </div>
        </div>
      </get-more>
    </div>
    <div class="footer">
      <div class="left">
        <p>已筛选出以上找店信息</p>
        <span>发布后立即推送，安排看店洽谈</span>
      </div>
      <div class="footer-btn" @click="$router.push('/publish')">我要发布</div>
    </div>
    <van-dialog
      v-model="show"
      :show-cancel-button="false"
      :show-confirm-button="false"
    >
      <div class="dialog">
        <div class="cancel" @click="show = false">
          <img src="@/imgs/more/cancels.png"/>
        </div>
        <h1>提示</h1>
        <p v-if="!hasPay">
          请您先发布信息，<br>
          发布后会把您的信息推广推送给<br>
          适合的找店求租用户
        </p>
        <p v-else>
          您好，已成功为您匹配<br>
          所有适合您的找店用户，<br>
          请保持电话畅通，<br>
          点击首页商铺信息查看您的信息
        </p>
        <div @click="hasPay?show = false:$router.push('/publish')">{{ hasPay?'关闭':'立即发布' }}</div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import LoadMore from '@/components/LoadMore'
import { getRentList, myPublish, getUserInfo } from '@/api/api'
import { getLocation } from '@/utils/location'
import { headers } from '@/utils/util'
export default {
  name: 'Rent',
  components: {
    getMore: LoadMore
  },
  data() {
    return {
      hasPay: false,
      loadMoreText: '加载中...',
      show: false,
      cityName: this.$store.getters.cityName,
      envId: parseInt(process.env.VUE_APP_SERVER_ID),
      isLook: false,
      rentList: [],
      page: 1,
      size: 10,
      enableLoadMore: true
    }
  },
  created() {
  },
  mounted() {
    this.getUserInfo()
    if (!this.$store.getters.cityName) {
      this.getLocation()
    }
    if (this.$store.getters.isType2) {
      this.dialogType = 2
      this.show = true
      this.$store.dispatch('setType2', false)
    }
    this.getList()
  },
  methods: {
    async getMyPublish() {
      try {
        const form = {
          page: 1,
          limit: 100
        }
        const res = await myPublish(headers(form), form)
        const payList = res.data.filter(s => {
          return s.publishStatus === '2'
        })
        if (payList.length) {
          this.hasPay = true
        }
      } catch {
        console.log('err')
      }
    },
    async getUserInfo() {
      try {
        await getUserInfo(headers())
        this.getMyPublish()
      } catch {
        console.log('err')
      }
    },
    onLoadMore(done) {
      setTimeout(() => {
        if (!this.enableLoadMore) {
          return
        }
        this.page = this.page + 1
        this.getList()
        done()
      }, 200)
      // if (!this.enableLoadMore) {
      //   return
      // }
      // this.page = this.page + 1
      // this.getList()
      // done()
    },
    getPhone() {
      this.show = true
    },

    nextRouter(item, ids) {
      if (ids.includes(item.publishId)) {
        const a = document.createElement('a')
        a.href = `tel:${item.phone}`
        a.style.display = 'none'
        a.click()
      } else {
        this.show = true
        this.dialogType = 1
      }
    },

    tellThis(item, ids) {
      let arr = []
      if (!ids.includes(item.publishId)) {
        arr = [...ids, item.publishId]
        localStorage.setItem('lookIds', JSON.stringify(arr))
      }
      const a = document.createElement('a')
      a.href = `tel:${item.phone}`
      a.style.display = 'none'
      a.click()
    },

    async getLocation() {
      const res = await getLocation()
      const city = res.data.city
      await this.$store.dispatch('setCity', city)
      this.cityName = city
    },
    getList() {
      const { page, size = 10 } = this
      let rentList = []
      getRentList({ page, size, trade: this.$store.getters.tradeId }).then(
        (res) => {
          if (res.data.length === 0) {
            this.loadMoreText = '~ 到底了 ~'
            this.page = page - 1
          } else {
            if (page === 1) {
              rentList = res.data.sort(() => Math.random() - 0.5)
            } else {
              rentList = res.data
            }
            console.log(rentList)
            this.rentList = this.rentList.concat(rentList)
          }
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.main {
  padding: 30px 30px 130px 30px;
  .stores {
    width: 690px;
    display: flex;
    flex-direction: column;
    .store {
      margin-bottom: 30px;
      width: 690px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 5px 25px 0px rgba(255, 209, 197, 0.1);
      border-radius: 12px;
      padding: 29px 30px 21px 30px;
      direction: flex;
      flex-direction: column;
      .store-title {
        width: 100%;
        display: flex;
        align-items: center;
        h1 {
          flex: 1;
          font-size: 28px;
          font-family: PingFang SC;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          line-height: 30px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
        span {
          margin-left: 19px;
          width: 94px;
          height: 28px;
          line-height: 28px;
          text-align: center;
          background: rgba(255, 241, 237, 1);
          border-radius: 4px;
          font-size: 18px;
          font-family: PingFang SC;
          font-weight: 800;
          color: rgba(255, 106, 74, 1);
        }
      }
      .content {
        margin: 20px 0 17px 0;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 500;
        color: rgba(153, 153, 153, 1);
        line-height: 34px;
      }
      .store-chat {
        display: flex;
        justify-content: space-between;
        align-items: center;
        p {
          font-size: 24px;
          font-family: PingFang SC;
          font-weight: 500;
          color: rgba(153, 153, 153, 1);
        }
        div {
          display: flex;
          height: 48px;
          align-items: center;
          background: rgba(255, 91, 58, 1);
          border-radius: 8px;
          padding: 0 19px;
          img {
            margin-right: 13px;
            width: 26px;
            height: 26px;
          }
          span {
            font-size: 28px;
            font-family: PingFang SC;
            font-weight: 500;
            color: rgba(255, 255, 255, 1);
          }
        }
      }
    }
  }
  .footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100vw;
    height: 100px;
    z-index: 10;
    background: #ffffff;
    display: flex;
    .left {
      flex: 1;
      padding: 22px 0 22px 38px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      p,
      span {
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #999999;
        line-height: 30px;
      }
      span {
        color: #ff5b3b;
      }
    }
    .footer-btn {
      width: 250px;
      height: 100px;
      line-height: 100px;
      text-align: center;
      background: #ff5b3b;
      font-size: 32px;
      font-family: PingFang SC;
      font-weight: 800;
      color: #ffffff;
    }
  }
  .dialog {
    display: flex;
    flex-direction: column;
    background: rgba(255, 255, 255, 1);
    border-radius: 8px;
    padding: 0 63px 39px 63px;

    .cancel {
      position: absolute;
      width: 60px;
      height: 60px;
      right: 12px;
      top: -50px;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        display: block;
        width: 48px;
        height: 48px;
      }
    }
    h1 {
      font-size: 36px;
      line-height: 120px;
      text-align: center;
      font-family: PingFang SC;
      font-weight: 800;
      color: rgba(51, 51, 51, 1);
    }
    p {
      font-size: 28px;
      white-space: nowrap;
      text-align: center;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      line-height: 36px;
    }
    div {
      margin: 62px auto 0 auto;
      width: 300px;
      height: 80px;
      text-align: center;
      line-height: 80px;
      background: rgba(253, 106, 66, 1);
      border-radius: 8px;
      font-size: 32px;
      font-family: PingFang SC;
      font-weight: 800;
      color: rgba(254, 254, 254, 1);
    }
  }
}
</style>
